/* eslint-disable @typescript-eslint/no-explicit-any */
import z from "zod"

import {
  ProjectCollaborationMessage,
  ProjectCollaborationMessageType
} from "../types/ProjectCollaborationEvent"

// A malformed change list must not drop the message: without it, the message
// falls back to a full refresh.
const ProjectCollaborationChangesSchema = z
  .array(
    z.object({
      changeType: z.enum(["create", "update", "delete"]),
      resourceType: z.string(),
      resourceId: z.string().optional()
    })
  )
  .optional()
  .catch(undefined)

const ProjectCollaborationEventSchema = z.object({
  message: z.enum(ProjectCollaborationMessageType),
  project: z.object({
    id: z.string()
  }),
  changes: ProjectCollaborationChangesSchema
})

export function parseProjectCollaborationEvent(
  event: any
): ProjectCollaborationMessage | null {
  const result = z.safeParse(ProjectCollaborationEventSchema, event)
  return result.success ? result.data : null
}
